import React from 'react';
import { IorganizationBusinessData } from '../../../../../types/bussines';
import PlanType from './components/PlanType';
import OrganizationKamAssignments from './components/OrganizationKamAssignments/OrganizationKamAssignments';
import TagFiltering from '../OrgDataSection/components/TagFiltering/TagFiltering';
import ClientType from './components/ClientType';
import './OrgDataAccount.scss';

const OrgDataAccount = ({
  organizationData,
  updateWithoutLoaders
}: {
  organizationData: IorganizationBusinessData;
  updateWithoutLoaders?: () => Promise<void>;
}) => {
  const { id } = organizationData;
  const organizationId = id.toString();

  return (
    <div id="orgDataAccount">
      <ClientType organizationId={organizationId} updateWithoutLoaders={updateWithoutLoaders} />
      <div className="divider" />
      <PlanType organizationId={organizationId} updateWithoutLoaders={updateWithoutLoaders} />
      {organizationData && updateWithoutLoaders && (
        <>
          <TagFiltering organizationData={organizationData} updateWithoutLoaders={updateWithoutLoaders} />
          <div className="divider" />
        </>
      )}
      {updateWithoutLoaders && (
        <>
          <OrganizationKamAssignments
            organizationId={organizationId}
            organizationData={organizationData}
            updateWithoutLoaders={updateWithoutLoaders}
          />
          <div className="divider" />
        </>
      )}
    </div>
  );
};

export default OrgDataAccount;
